export default __webpack_public_path__ + "img/jtc/jtc1_700.webp";